import { getItemColor } from "utils/dynamicDashboard";
import { getCSSVar } from "utils/styling";

const ENERGY_ANALYSIS_UTILITY_COLOR_TOKEN: Record<string, string> = {
  biogas: "--core-color-tangerine-500",
  coal: "--core-color-neutral-black",
  district_heat: "--core-color-mystic-red-600",
  grid_electricity: "--core-color-vivid-orchid-600",
  heat_steam: "--core-color-leaftech-blue-300",
  lpg: "--core-color-tangerine-700",
  natural_gas: "--core-color-star-500",
  oil: "--core-color-tangerine-900",
  wood_chips: "--core-color-cathode-green-600",
  wood_pellets: "--core-color-cathode-green-800",
};

export const getEnergyAnalysisColor = (key: string, index: number) => {
  const token = ENERGY_ANALYSIS_UTILITY_COLOR_TOKEN[key];
  if (token) {
    const utilityColor = getCSSVar(token);
    if (utilityColor.length > 0) return utilityColor;
  }
  const color = getItemColor(index);
  if (color.length > 0) return color;
  return (
    getCSSVar("--core-color-secondary-blue-600") ||
    getCSSVar("--color-foreground-primary") ||
    "#3f748c"
  );
};

export const buildCategoryColorMap = (keys: string[]) => {
  const colors: Record<string, string> = {};
  keys.forEach((key, index) => {
    colors[key] = getEnergyAnalysisColor(key, index);
  });
  return colors;
};
